import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "..";
import findUserName from "./finsUserName";

const getRatings = async (whiskeyId) => {

    const q = query(collection(db, "rating"), where("whiskeyId", "==", whiskeyId));
    const ratings1 = []
    const ratings2 = []
    const ratings3 = []
    let score = 0
    let _fullName
    const querySnapshot = await getDocs(q);
    for (const doc of querySnapshot.docs) {
        _fullName = await findUserName(doc.data().userId)
        score = score + doc.data().score
        switch (doc.data().type) {
            case 1:
                ratings1.push({ id: doc.id, score: doc.data().score, userId: _fullName.user.id, created: doc.data().created })
                break;
            case 2:
                ratings2.push({ id: doc.id, score: doc.data().score, userId: _fullName.user.id, created: doc.data().created })
                break;

            case 3:
                ratings3.push({ id: doc.id, score: doc.data().score, userId: _fullName.user.id, created: doc.data().created })
                break;
        }
    };
    const averageScore = ratings1.length + ratings2.length + ratings3.length
    score = score / averageScore
    return { ratings1, ratings2, ratings3, score }
}

export default getRatings